import {DatasetEntryI} from "../../db/models/dataset";

export const datasetIdToLabel = (dataset: DatasetEntryI[], id?: number): string => {
    if (id === null || id === undefined || id < 0 || id >= dataset.length) return "";
    const found = dataset.find(e => e.id === id);

    if (found) return found.label;
    else return "";
}

export const datasetIdToEntry = (dataset: any[], id: number) => {
    const found = dataset.find(e => e.id === id);

    if (found) return found;
    else return null;
}